import axiosInstance from '../../../axiosInstance';
import apiEndpoints from '../../../api';

// Per-society outgoing mail (SMTP) accounts. The society always goes in
// X-Society-Id — it's the community being configured, not the admin's active one.
// `:id` is the record's uuid. The password is write-only: never returned.

const ctx = (societyId) => ({ headers: { 'X-Society-Id': societyId } });
const byId = (uuid) => apiEndpoints.CTRL_SMTP_CONFIG_API.replace(':id', uuid);

// Validation 400s use { status, message: "body: …" }; others the standard envelope.
export const smtpConfigErrorMessage = (err) =>
    String(err?.response?.data?.message || err?.message || 'Something went wrong')
        .replace(/^(body|query|params):\s*/, '');

// GET → SmtpConfig[] (default first, then by config_name). isActive: 0 | 1 | undefined
export const listSmtpConfigsReq = (societyId, isActive) =>
    axiosInstance.get(apiEndpoints.CTRL_SMTP_CONFIGS_API, {
        ...ctx(societyId),
        params: isActive == null ? undefined : { is_active: isActive },
    });

// GET one → SmtpConfig. The view modal calls it on "Show" and reads `password` if the API returns it.
export const getSmtpConfigReq = (societyId, uuid) =>
    axiosInstance.get(byId(uuid), ctx(societyId));

export const createSmtpConfigReq = (societyId, body) =>
    axiosInstance.post(apiEndpoints.CTRL_SMTP_CONFIGS_API, body, ctx(societyId));

// PUT — partial: send only changed fields. Leave out `password` to keep the saved one.
export const updateSmtpConfigReq = (societyId, uuid, body) =>
    axiosInstance.put(byId(uuid), body, ctx(societyId));

// Permanent delete — use update { is_active: 0 } to switch an account off instead.
export const deleteSmtpConfigReq = (societyId, uuid) =>
    axiosInstance.delete(byId(uuid), ctx(societyId));
